import React, { useState, useEffect } from "react";
import axios from "axios";

export default function News() {
  const [mainData, setMainData] = useState([]);
  const [quarterlyResults, setQuarterlyResults] = useState([]);
  useEffect(() => {
    axios
      .get("/data/recommendations.json")
      .then((res) => {
        // The data is available directly on res.data
        setMainData(res.data.reverse());
      })
      .catch((err) => {
        // The error object is slightly different, but you can still log it
        console.error("Failed to load updates:", err);
      });

    // API call 2
    axios
      .get("/data/results.json")
      .then((response) => {
        setQuarterlyResults(response.data);
      })
      .catch((error) => {
        console.error("Error fetching quarterly results:", error);
      });
  }, []);

  return (
    <div className="updates-section">
      <main className="weekly-stocks">
        <div className="table-responsive">
          <table class="table table-hover recommendations-table">
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>Current Price</th>
                <th>Target</th>
                <th>Recommeded By</th>
              </tr>
            </thead>

            <tbody>
              {mainData.map((i) => {
                return (
                  <tr>
                    <td>{i.companyName}</td>
                    <td>{i.cmp}</td>
                    <td>{i.target}</td>
                    <td>{i.firm}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </main>
      <aside className="quarterly-stocks">
        <h5 className="heading">QUARTERLY RESULTS ANNOUNCEMENTS</h5>
        {/* <p>Get highly curated stock recommendations by experts & top firms!</p> */}
        <div className="">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {quarterlyResults.map((i) => {
                return (
                  <tr>
                    <td>{i.companyName}</td>
                    <td>{i.date}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </aside>
    </div>
  );
}
